import PostPreview from './post-preview'
import type Post from '../../interfaces/post'

type Props = {
    posts: Post[]
}

const MoreStories = ({posts}: Props) => {
    return (
        <>
            <h1 className="mb-4 font-bold fs-2 text-primary">
                Latest Blogs
            </h1>
            <div className="row">
                {posts.map((post, index) => (
                    <div key={index} className="col col-12 col-md-6">
                        <PostPreview
                            key={post.slug}
                            title={post.title}
                            coverImage={post.coverImage}
                            date={post.date}
                            author={post.author}
                            slug={post.slug}
                            excerpt={post.excerpt}
                        />
                    </div>
                ))}
            </div>
        </>
    )
}

export default MoreStories
